export enum Privileges {
  VIEW_DASHBOARD = "VIEW_DASHBOARD",
  CREATE = "CREATE",
  READ = "READ",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  PRINT = "PRINT",
  EXPORT = "EXPORT",
  ADD_USER = "ADD_USER",
  EXPORT_USER = "EXPORT_USER",
  VIEW_USER = "VIEW_USER",
  EDIT_USER = "EDIT_USER",
  RESENT_ACTIVATION_LINK = "RESENT_ACTIVATION_LINK",
  RESET_PASSWORD = "RESET_PASSWORD",
  PRINT_USER = "PRINT_USER",
  DELETE_USER = "DELETE_USER",
  VIEW_CUSTOMER = "VIEW_CUSTOMER",
  ADD_ISO = "ADD_ISO",
  ADD_SUB_ISO = "ADD_SUB_ISO",
  EDIT_CUSTOMER = "EDIT_CUSTOMER",
  DELETE_CUSTOMER = "DELETE_CUSTOMER",
  EXPORT_CUSTOMER = "EXPORT_CUSTOMER",
  PRINT_CUSTOMER = "PRINT_CUSTOMER",
  VIEW_APPLICATION = "VIEW_APPLICATION",
  ADD_APPLICATION = "ADD_APPLICATION",
  VIEW_DEVICE = "VIEW_DEVICE",
  ADD_ASSET = "ADD_ASSET",
  EDIT_ASSET = "EDIT_ASSET",
  VIEW_ASSET = "VIEW_ASSET",
  DELETE_ASSET = "DELETE_ASSET",
  VIEW_DOWNLOAD_LOG = "VIEW_DOWNLOAD_LOG",
  VIEW_MERCHANT = "VIEW_MERCHANT",
  PAYMENTS = "PAYMENTS",
  VIEW_DEVICE_ALERT = "VIEW_DEVICE_ALERT",
  ADD_MERCHANT = "ADD_MERCHANT",
  ADD_PROMOTIONAL_SETTING = "ADD_PROMOTIONAL_SETTING",
  EDIT_PROMOTIONAL_SETTING = "EDIT_PROMOTIONAL_SETTING",
  VIEW_BATCHES = "VIEW_BATCHES",
  MAKE_SETTLEMENT = "MAKE_SETTLEMENT",
  ADD_TPN = "ADD_TPN",
  HELP_DESK = "HELP_DESK",
  VIEW_TICKET = "VIEW_TICKET",
  EDIT_ACTIONS = "EDIT_ACTIONS",
  DELETE_MERCHANT = "DELETE_MERCHANT",
  ADD_CUSTOMER = "ADD_CUSTOMER",
  ADD_STORE = "ADD_STORE",
  EDIT_STORE = "EDIT_STORE",
  EDIT_TPN = "EDIT_TPN",
  EXPORT_MERCHANT = "EXPORT_MERCHANT",
  PRINT_MERCHANT = "PRINT_MERCHANT",
  EDIT_MERCHANT = "EDIT_MERCHANT",
  DELETE_STORE = "DELETE_STORE",
  DELETE_TPN = "DELETE_TPN",
  ASSIGN_BUILD = "ASSIGN_BUILD",
  EDIT_PARAM = "EDIT_PARAM",
  VIEW_ASSETS = "VIEW_ASSETS",
  EDIT_ASSETS = "EDIT_ASSETS",
  DELETE_ASSETS = "DELETE_ASSETS",
  ADD_ASSETS = "ADD_ASSETS",
  ADD_DEVICE_MODELS = "ADD_DEVICE_MODELS",
  EDIT_DEVICE_MODELS = "EDIT_DEVICE_MODELS",
  DELETE_DEVICE_MODELS = "DELETE_DEVICE_MODELS",
  VIEW_TRANSACTION = "VIEW_TRANSACTION",
  VIEW_RECEIPT = "VIEW_RECEIPT",
  REFUND_TRANSACTION = "REFUND_TRANSACTION",
  VOID_TRANSACTION = "VOID_TRANSACTION",
  TICKET_TRANSACTION = "TICKET_TRANSACTION",
  EXPORT_TRANSACTION = "EXPORT_TRANSACTION",
  SETTLE_BATCH = "SETTLE_BATCH",
  EXPORT_BATCH = "EXPORT_BATCH",
  TIP_ADJUST = "TIP_ADJUST",
  INVOICE_LIST = "INVOICE_LIST",
  UPLOAD_INVOICE = "UPLOAD_INVOICE",
  SEND_PAYMENT_LINK = "SEND_PAYMENT_LINK",
  PAY_NOW = "PAY_NOW",
  EDIT_INVOICE = "EDIT_INVOICE",
  VIEW_INVOICE_LIST = "VIEW_INVOICE_LIST",
  VIEW_CONSUMER = "VIEW_CONSUMER",
  RUN_A_SALE = "RUN_A_SALE",
  ADD_CONSUMER = "ADD_CONSUMER",
  EDIT_CONSUMER = "EDIT_CONSUMER",
  DELETE_CONSUMER = "DELETE_CONSUMER",
  ADD_CARD = "ADD_CARD",
  EDIT_CARD = "EDIT_CARD",
  DELETE_CARD = "DELETE_CARD",
  EXPORT_CONSUMER = "EXPORT_CONSUMER",
  SETTLE_EMAIL_ALERT = "SETTLE_EMAIL_ALERT",
  DEVICE_TOKEN_TOP = "DEVICE_TOKEN_TOP",
  UPDATE_GHPP_TAG = "UPDATE_GHPP_TAG",
  MERCHANT_UPLOAD_LOGO = "MERCHANT_UPLOAD_LOGO",
  VIEW_AUDITLOGS = "VIEW_AUDITLOGS",
  VIEW_AUDIT_LOGS = "VIEW_AUDIT_LOGS",
  ADD_NOTES = "ADD_NOTES",
  VIEW_NOTES = "VIEW_NOTES",
  SPIN_PROXY = "SPIN_PROXY",
  ADD_CONTRACT = "ADD_CONTRACT",
  EDIT_CONTRACT = "EDIT_CONTRACT",
  VIEW_INVOICE = "VIEW_INVOICE",
  GENERATE_BILLING = "GENERATE_BILLING",
  VIEW_RECURRING_PAYMENT_LIST = "VIEW_RECURRING_PAYMENT_LIST",
  RECURRING_PAYMENT_EMAIL_ALERT = "RECURRING_PAYMENT_EMAIL_ALERT",
  DOWNLOAD_RECURRING_PAYMENTS_LIST = "DOWNLOAD_RECURRING_PAYMENTS_LIST",
  SETUP_RECURRING_PAYMENT = "SETUP_RECURRING_PAYMENT",
  CANCEL_RECURRING_PAYMENT = "CANCEL_RECURRING_PAYMENT",
  EXTERNAL_HOST = "EXTERNAL_HOST",
  DELETE_POS_PARAM = "DELETE_POS_PARAM",
  VIEW_PROXY_LOGS = "VIEW_PROXY_LOGS",
  EXTERNAL_DOCUMENT = "EXTERNAL_DOCUMENT",
  ADD_PROMOTION="ADD_PROMOTION",
  EDIT_PROMOTION="EDIT_PROMOTION",
  DELETE_PROMOTION="DELETE_PROMOTION",
  API_KEY_GENERATION = "API_KEY_GENERATION",
  VIEW_PROMOTION = "VIEW_PROMOTION",
  VIEW_INVENTORY = "VIEW_INVENTORY",
  ADD_INVENTORY = "ADD_INVENTORY",
  EDIT_INVENTORY = "EDIT_INVENTORY",
  DELETE_INVENTORY = "DELETE_INVENTORY",
  STOP_RENTAL = "STOP_RENTAL",
  RENTAL_REPLACEMENT = "RENTAL_REPLACEMENT",
  VIEW_RENTAL = "VIEW_RENTAL",
  EXTERNAL_MERCHANT_BOARDING = "EXTERNAL_MERCHANT_BOARDING",
  PAYMENT_NOTIFICATIONS = "PAYMENT_NOTIFICATIONS",
  PROCESS_REFUND="PROCESS_REFUND",
  REMOVE_FEE="REMOVE_FEE",
  EDIT_DEVICE_LABEL = "EDIT_DEVICE_LABEL",
  ADDITIONAL_AUTH = "ADDITIONAL_AUTH",
  VIEW_TIP_REPORT = "VIEW_TIP_REPORT",
  VIEW_SETTLEMENT_REPORT = "VIEW_SETTLEMENT_REPORT",
  VIEW_BATCH_REPORT = "VIEW_BATCH_REPORT",
  VIEW_INVENTORY_REPORT = "VIEW_INVENTORY_REPORT",
  VIEW_CUSTOMER_SUPPORT_VIDEOS = "VIEW_CUSTOMER_SUPPORT_VIDEOS",
  MULTI_REFUND = "MULTI_REFUND",
  STORE_CHANGE = "STORE_CHANGE",
  PROXY_LOGIN = "PROXY_LOGIN",
  BULK_ASSIGN = "BULK_ASSIGN",
  VIEW_RISK_DETAILS = "VIEW_RISK_DETAILS",
  EDIT_RISK_DETAILS = "EDIT_RISK_DETAILS",
  ACTIVATE_TPN = "ACTIVATE_TPN",
  VIEW_RISK_TEMPLATES = "VIEW_RISK_TEMPLATES",
  EDIT_RISK_TEMPLATES = "EDIT_RISK_TEMPLATES",
  DELETE_RISK_TEMPLATES = "DELETE_RISK_TEMPLATES",
  EXPORT_TPN = "EXPORT_TPN",
  VIEW_MARKET_APP = "VIEW_MARKET_APP",
  EDIT_MARKET_APP = "EDIT_MARKET_APP",
  DELETE_MARKET_APP = "DELETE_MARKET_APP",
  ASSIGN_ANCHOR_APP="ASSIGN_ANCHOR_APP",
  VIEW_THIRDPARTY_APP="VIEW_THIRDPARTY_APP",
  ASSIGN_THIRDPARTY_APP="ASSIGN_THIRDPARTY_APP",
  ADD_NON_GATEWAY_TPN="ADD_NON_GATEWAY_TPN",
  EDIT_NON_GATEWAY_TPN="EDIT_NON_GATEWAY_TPN",
  DELETE_NON_GATEWAY_TPN="DELETE_NON_GATEWAY_TPN",
  VIEW_NON_GATEWAY_TPN="VIEW_NON_GATEWAY_TPN",
  EDIT_CUSTOMER_ASSET="EDIT_CUSTOMER_ASSET",
  EXPORT_ASSETS="EXPORT_ASSETS",
  FIRMWARE_BULK_UPDATE="FIRMWARE_BULK_UPDATE",
  ADD_VALUE_ADDED_APPS="ADD_VALUE_ADDED_APPS",
  MANAGE_DVSTORE="MANAGE_DVSTORE",
  VALUE_ADDED_APPS="VALUE_ADDED_APPS",
  BULK_ASSIGN_VALUE_ADDED_APP="BULK_ASSIGN_VALUE_ADDED_APP",
  VIEW_BETA_SEARCH="VIEW_BETA_SEARCH",
  DOWNGRADE_BUILD = "DOWNGRADE_BUILD",
  ADD_CAMPAIGN = "ADD_CAMPAIGN",
  DELETE_CAMPAIGN = "DELETE_CAMPAIGN",
  VIEW_CAMPAIGN = "VIEW_CAMPAIGN",
  VIEW_MULTI_MID = "VIEW_MULTI_MID",
  CREATE_MULTI_MID = "CREATE_MULTI_MID",
  EDIT_MULTI_MID = "EDIT_MULTI_MID",
  DELETE_MULTI_MID = "DELETE_MULTI_MID",
  COMMUNICATION_CENTER = "COMMUNICATION_CENTER",
  COMMAND_CENTER = "COMMAND_CENTER",
  VIEW_CHATBOT = "VIEW_CHATBOT",
  CARD_UPDATER = "CARD_UPDATER",
  VIEW_BILLING = "VIEW_BILLING",
  EDIT_BILLING = "EDIT_BILLING",
  ADD_BANK = "ADD_BANK",
  SEND_COMMAND = "SEND_COMMAND",
  SEND_COMMUNICATION = "SEND_COMMUNICATION",
  PAYMENT_METHODS = "PAYMENT_METHODS",
  ADD_DESIGNER_TOOL="ADD_DESIGNER_TOOL",
  VIEW_DESIGNER_TOOL="VIEW_DESIGNER_TOOL",
  DELETE_DESIGNER_TOOL="DELETE_DESIGNER_TOOL",
  API_DOCS = "API_DOCS",
  KNOWLEDGE_BASE = "KNOWLEDGE_BASE",
  RELEASE_NOTES="RELEASE_NOTES",
  CREATE_INVOICE="CREATE_INVOICE",
  VIEW_TERMINAL="VIEW_TERMINAL",
  EDIT_VENDING_CONFIGURATION="EDIT_VENDING_CONFIGURATION",
  EDIT_IPOSPAYS_CONFIGURATION="EDIT_IPOSPAYS_CONFIGURATION",
  REMOTE_COMMANDS="REMOTE_COMMANDS",
  VIEW_DISPENSER="VIEW_DISPENSER",
  VIEW_DEX_AUDIT="VIEW_DEX_AUDIT",
  VIEW_WEBHOOK_LOG="VIEW_WEBHOOK_LOG",
  VIEW_DEJAUP_TRANSACTION="VIEW_TRANSACTION",
  VIEW_WEBHOOK="VIEW_WEBHOOK",
  VIEW_ISV="VIEW_ISV",
  ADD_ISV="ADD_ISV",
  EDIT_ISV="EDIT_ISV",
  DELETE_ISV="DELETE_ISV",
  EXPORT_ISV="EXPORT_ISV",
  MY_APP_VIEW="MY_APP_VIEW",
  MY_APP_ADD_UPDATE="MY_APP_ADD_UPDATE",
  MY_APP_ASSIGN_BUILD="MY_APP_ASSIGN_BUILD",
  EDIT_ISV_PRIVILEGE="EDIT_ISV_PRIVILEGE"
}
